<template lang="pug">
div
  e-z-toolbar(
    :title="'Inventory'",
    @counterSelected="openCounter($event)",
    @allSelected="openRestaurant()"
  )
  v-container.pa-0(fluid)
    v-row(justify-left, no-gutters)
      v-col(cols="12", xs="10", sm="5", lg="3")
        v-text-field.pb-1.pt-1.pl-4.pr-4(
          v-model="search",
          append-icon="mdi-magnify",
          label="Quick Search",
          clearable,
          single-line,
          hide-details
        )
      //
        <v-col xs1 sm1 lg1 class="pl-2">
        <v-btn fab small color="grey" @click="vibrate();alert('lookup'+ search)">
        <v-icon>mdi-plus</v-icon>
        </v-btn>
        </v-col>
    v-row(justify-left, no-gutters)
      v-col(
        v-for="group in productGroups",
        :key="group.name",
        cols="12",
        xs="12",
        sm="6",
        md="4",
        lg="3",
        xl="2"
      )
        v-sheet(color="grey lighten-2")
          v-row(no-gutters)
            v-col
              .pl-3.pr-3
                div(style="float: left")
                  v-icon(small) mdi-plus-box-multiple
                  //
                    <v-icon
                    small
                    v-if="group.expanded"
                    @click="group.expanded=!group.expanded;alert(group.expanded)"
                    >indeterminate_check_box</v-icon>
                    <v-icon
                    v-if="!group.expanded"
                    small
                    @click="group.expanded=!group.expanded;alert(group.expanded)"
                    >add_box</v-icon>
                  strong.pl-2 {{ group.name }}: ({{ group.products.length }})
                //
                  In case required for tools <div v-if="group.isPrintable" style="float:right">
                  <v-icon small>print</v-icon>
                  <strong>Print</strong>
                  </div>
          v-card
            v-divider
            v-card-text.pa-0(
              v-for="product in group.products",
              :key="product.id"
            )
              v-list-item
                v-list-item-avatar(tile)
                  img(:src="product.imageUrl || '/images/product.png'")
                v-list-item-content
                  v-list-item-title(
                    v-text="product.name + '(' + product.code + ')'"
                  )
                  v-list-item-subtitle(
                    v-text="'(' + (product.counterCode || '') + ') Tags: ' + (product.tags || []).join(',')"
                  )
                v-list-item-action
                  v-list-item-action-text(
                    v-if="product._restaurantKey != null"
                  )
                    code {{ product.count }}
                  v-list-item-action-text(v-if="!product.isGroupProduct")
                    v-icon.pl-3(@click="vibrate(); editItem(product)") mdi-pencil
                  v-list-item-action-text(v-if="product.isGroupProduct")
                    v-icon(
                      v-if="!product.isAdded",
                      color="primary",
                      @click="vibrate(); addToRestaurant(product)"
                    ) mdi-arrow-up-box
                    v-icon(
                      v-if="product.isChanged",
                      color="red",
                      @click="vibrate(); addToRestaurant(product)"
                    ) mdi-call-merge
              v-divider
  product-dialog(
    v-if="mode.productDialog",
    :editedItem="editedItem",
    :mode="mode",
    v-on:save="save($event)",
    v-on:delete="deleteItem($event)"
  )
</template>

<script>
import EZToolbar from "../components/shared/EZToolbar.vue";
import ProductDialog from "../components/dialogs/Product.vue";
import { storeMixin } from "../mixins/storeMixin.js";

export default {
  name: "items",
  mixins: [storeMixin],
  components: { EZToolbar, ProductDialog },
  async beforeMount() {
    if (["GA", "RM"].includes(this.selectedUser && this.selectedUser.role)) {
      await this.loadSourcedProducts();
    }
  },
  data() {
    return {
      routeParams: {},
      mode: {
        productDialog: false,
      },
      search: "",
      isRestaurantOpen: false,
      editedItem: {},
      sourcedProducts: [],
    };
  },
  computed: {
    filteredProducts() {
      let products = this.isRestaurantOpen
        ? [...this.restaurantProducts, ...this.sourcedProducts]
        : this.restaurantProducts.filter(
            (p) => p._counterKey === this.selectedCounter.id
          );
      let filteredProducts = products.filter((p) => {
        if (this.search) {
          const text =
            p.name.toLowerCase() +
            p.code.toLowerCase() +
            (p.tags ? p.tags.join(",").toLowerCase() : "") +
            (p.desc ? p.desc.toLowerCase() : "") +
            (p.counterCode ? p.counterCode.toLowerCase() : "");
          const searchText =
            this.search !== 0 ? this.search.toLowerCase() : this.search;
          let found = true;
          const searchTerms = searchText.split(",");
          searchTerms.forEach((term) => {
            term = term ? term.trim() : false;
            found = term ? found && text.indexOf(term) > -1 : found;
          });
          return found;
        }
        return true;
      });
      return filteredProducts;
    },
    productGroups() {
      const productGroups = [
        {
          name: "Counter Products",
          products: this.filteredProducts.filter((p) => !p.isGroupProduct),
        },
      ];
      if (this.isRestaurantOpen) {
        productGroups[0].name = "Restaurant Products";
        productGroups.push({
          name: "Group Products",
          products: this.filteredProducts.filter(
            (p) => p.isGroupProduct && (!p.isAdded || p.isChanged)
          ),
        });
      }
      return productGroups;
    },
  },
  methods: {
    openCounter(counter) {
      this.selectCounter(counter);
      this.isRestaurantOpen = false;
    },
    openRestaurant() {
      this.isRestaurantOpen = true;
    },
    editItem(product) {
      this.editedItem = Object.assign({}, product);
      this.mode.productDialog = true;
    },
    async loadSourcedProducts() {
      const predicates = [
        { key: "status", op: "==", val: this.STATUSES.ACTIVE },
        { key: "_groupKey", op: "==", val: this.selectedGroup.id },
        { key: "isGroupProduct", op: "==", val: true },
      ];
      this.sourcedProducts = await this.loadDocs({
        collectionName: "products",
        predicates: predicates,
      });
      //mark those products which are already added to restaurantProducts
      this.sourcedProducts.forEach((sp) => {
        sp.isAdded = false;
        sp.isChanged = false;
        const dupe = this.restaurantProducts.find((rp) => rp.code === sp.code);
        sp.isChanged = dupe && (dupe.name != sp.name || dupe.desc != sp.desc);
        sp.isAdded = !!dupe;
      });
    },
    async addToRestaurant(product) {
      let dupeProduct = this.restaurantProducts.find(
        (p) => p.code === product.code
      );
      if (dupeProduct) {
        if (
          await this.$confirm(
            "Product already added. Do you want to overwrite?"
          )
        ) {
          const dupeId = dupeProduct.id;
          this.editedItem = Object.assign({}, dupeProduct);
          Object.assign(this.editedItem, product);
          this.editedItem.id = dupeId;
          delete this.editedItem.isAdded;
          delete this.editedItem.isChanged;
          this.editedItem.isGroupProduct = false;
          this.mode.productDialog = true;
        }
      } else {
        this.editedItem = {
          _counterKey: this.selectedCounter.id,
          counterCode: this.selectedCounter.code,
          _restaurantKey: this.selectedRestaurant.id,
        };
        Object.assign(this.editedItem, product);
        this.editedItem.isGroupProduct = false;
        delete this.editedItem.id;
        delete this.editedItem.isAdded;
        delete this.editedItem.isChanged;
        this.editedItem.status = 1;
        this.mode.productDialog = true;
      }
    },
    save(payLoad) {
      if (payLoad.doc.id) {
        delete payLoad.doc.id;
        const pcode = payLoad.doc.code;
        this.updateDoc(payLoad);
        const sp = this.sourcedProducts.find((sp) => sp.code == pcode);
        if (sp) {
          sp.isChanged = false;
        }
      } else {
        this.createDoc(payLoad);
        //mark as added in sourcedProducts
        const pcode = payLoad.doc.code;
        const sp = this.sourcedProducts.find((sp) => sp.code == pcode);
        sp.isAdded = true;
        sp.isChanged = false;
      }
    },
    deleteItem(payLoad) {
      this.deleteDoc(payLoad);
    },
  },
};
</script>